import { useTranslations } from 'next-intl'

import IconCommunity from 'asset/icon/home/us_s.svg'
import IconSearch from 'asset/icon/search.svg'
import Headshot from 'component/block/headshot'
import { HeadshotSize } from 'constant'
import { type ISearchHistoryV2 } from 'type/search'
import SearchItem from './search-item'

interface IQueryItem {
  item: ISearchHistoryV2
}

const QueryItem = (props: IQueryItem) => {
  const { item } = props

  const t = useTranslations()

  if (item.type === 'user') {
    return (
      <SearchItem
        title={item.uid}
        description={item.name}
        prefix={<Headshot size={HeadshotSize.md} src={item.image} />}
      />
    )
  }
  if (item.type === 'community') {
    return (
      <SearchItem
        title={item?.title}
        description={t('community.count_join_members', {
          members: item.count
        })}
        prefix={
          <Headshot
            size={HeadshotSize.md}
            src={item.image}
            rounded={false}
            fallback={<IconCommunity className='sq-[24px]' />}
          />
        }
        iconShape='square'
      />
    )
  }
  if (item.type === 'keyword') {
    return (
      <SearchItem
        title={item.keyword}
        prefix={<IconSearch className='h-[18px] w-[18px] fill-label-l1' />}
      />
    )
  }

  return null
}

export default QueryItem
